import { render, staticRenderFns } from "./TheDocumentHistory.vue?vue&type=template&id=377f151e&scoped=true&"
import script from "./TheDocumentHistory.vue?vue&type=script&lang=js&"
export * from "./TheDocumentHistory.vue?vue&type=script&lang=js&"
import style0 from "./TheDocumentHistory.vue?vue&type=style&index=0&id=377f151e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "377f151e",
  null
  
)

export default component.exports